const TAX_RATE = 0.1;

export function multiplyWithTax(num:number, taxRate = TAX_RATE):number {
  return num * (1 + taxRate);
}
